import { defineStore } from 'pinia';

import axios from "axios";
import qs from 'qs';
import { Base64 } from 'js-base64'

import { useAppSettingStore, useChangePasswordStore } from '../index_SignIn';
import { store } from '../index_SignIn';

type SignInResult = {
  result?: boolean;
  needSetupEmail?: boolean;
  needChangePassword?: boolean;
  failureInfo?: string;
};

export const useSignInStore = defineStore('signin', {
  state: () => ({
    returnUrl: '',
    captchaId: '',
    mobileCompletionToken: '',
  }),
  getters: {

  },
  actions: {
    async signIn(router: any, username: string, password: string, captcha?: string, ticket?: string,
      randstr?: string, verificationToken?: string) {
      router.replace('/Result/info/正在登录/请稍候.../false');

      const appSettingStore = useAppSettingStore();
      const changePasswordStore = useChangePasswordStore();

      var signInResult: SignInResult = {};

      if (appSettingStore.signInCaptchaMode === '1') {
        const response = await axios.post('api/Authentication/ValidateSignInDirect', qs.stringify({
          'name': Base64.encode(username),
          'password': Base64.encode(password),
          'returnUrl': this.returnUrl
        }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        }
        ).catch(function (error) {
          console.log(error);
          return error?.response;
        });

        console.log(response);

        signInResult = response?.data || {};
      }
      else if (appSettingStore.signInCaptchaMode === '3') {
        const response = await axios.post('api/Authentication/ValidateSignInByTencentCaptcha', qs.stringify({
          'name': Base64.encode(username),
          'password': Base64.encode(password),
          'returnUrl': this.returnUrl,
          'ticket': ticket,
          'randstr': randstr
        }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        }
        ).catch(function (error) {
          console.log(error);
          return error?.response;
        });

        signInResult = response?.data || {};
      }
      else if (appSettingStore.signInCaptchaMode === '2') {
        const response = await axios.post('api/Authentication/ValidateSignInByCaptcha', qs.stringify({
          'name': Base64.encode(username),
          'password': Base64.encode(password),
          'returnUrl': this.returnUrl,
          'captchaId': this.captchaId,
          'captcha': captcha
        }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        }
        ).catch(function (error) {
          console.log(error);
          return error?.response;
        });

        this.handleGetCaptcha();

        signInResult = response?.data || {};
      }
      else if (appSettingStore.signInCaptchaMode === '4') {
        const response = await axios.post('api/Authentication/ValidateSignInBySlideCaptcha', qs.stringify({
          'name': Base64.encode(username),
          'password': Base64.encode(password),
          'returnUrl': this.returnUrl,
          'verificationToken': verificationToken
        }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        }).catch(function (error) {
          console.log(error);
          return error?.response;
        });

        signInResult = response?.data || {};
      }

      if (signInResult.result === true) {

        console.log(appSettingStore.enableRecoveryEmailOnLogin);

        if (signInResult.needSetupEmail === true && appSettingStore.enableRecoveryEmailOnLogin === true) {
          router.replace('/SetRecoveryEmail');
        }
        else {
          window.location.href = decodeURIComponent(this.returnUrl);
        }
      }
      else {
        if (signInResult.needChangePassword === true) {
          changePasswordStore.username = username;
          changePasswordStore.password = password;

          router.replace('/ChangePassword');
        }
        else {
          // 登录错误
          router.replace(`/Result/error/登录错误/${signInResult.failureInfo}/true/AccountPassword`);
        }
      }
    },
    handleGetCaptcha() {
      var rnd = Math.floor(Math.random() * (99999999 - 10000000)) + 10000000;
      this.captchaId = rnd.toString();
    }
  }
});

export function getSignInStore() {
  return useSignInStore(store);
}
